import TabPanel from "../../components/UtilitiesComponent/TabPanel";
import { Box, Tab, Tabs } from "@mui/material";
// import dynamic from "next/dynamic";
import styles from "../../styles/pages/published.module.scss"
import React, { memo, useEffect, useMemo } from "react";
import Chart from "react-apexcharts"
import axiosInstance from "../../api/axiosInstance";

const PublishedGraph = ({data = []}) => {

    const categoryList = useMemo(()=>{
     const filterData = data && data?.length > 0 && data.map((item) => item.month)
     return filterData;
    }, [data])

    const categoryValue = useMemo(()=>{
        const filterValue = data && data?.length > 0 && data.map((item) => item.total)
        return filterValue;
       }, [data])

    const [value, setValue] = React.useState(0);
    // const Chart = dynamic(() => import("react-apexcharts"), { ssr: false });
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const options = {
        xaxis: {
            categories: categoryList && categoryList.length > 0 ? categoryList : [],
              axisTicks: {
                show: false
              },
              
        },

        grid: {
            show: false,
            strokeDashArray: 0,
            borderColor: '#F3F3F3',
            padding: {
                left: -1
              }
        },
        yaxis: {
            labels: {
                offsetX: -7,
            }
        },
        dataLabels: {
            enabled: false
        },
        plotOptions: {
            bar: {
                borderRadius: 10,
                borderRadiusApplication: 'end',
            }
        }
    };

    const series = [
        {
            name: "series-1",
            data: categoryValue  && categoryValue.length > 0 ? categoryValue : [],
        },
    ];

    return (
        <>
            
            <Box className={styles.publishTabPanel}>
                <TabPanel value={value} index={0}>
                    <Box className="app">
                        <Box className="row">
                            <Box className={`${styles.mixedchartsec} mixed-chart`}>
                                <Chart
                                    options={options}
                                    series={series}
                                    type="bar"
                                    width={"100%"}
                                    height={"268"} />
                            </Box>
                        </Box>
                    </Box>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Box className="app">
                        <Box className="row">
                            <Box className={`${styles.mixedchartsec} mixed-chart`}>
                                <Chart
                                    options={options}
                                    series={series}
                                    type="bar"
                                    width={"100%"}
                                    height={"268"} />
                            </Box>
                        </Box>
                    </Box>
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <Box className="app">
                        <Box className="row">
                            <Box className={`${styles.mixedchartsec} mixed-chart`}>
                                <Chart
                                    options={options}
                                    series={series}
                                    type="bar"
                                    width={"100%"}
                                    height={"268"} />
                            </Box>
                        </Box>
                    </Box>
                </TabPanel>
            </Box>
        </>
    )

}

export default memo(PublishedGraph)
